export const API_ENDPOINTS = {
  CONTACT: "/api/contact",
  SNS: "/api/sns",
} as const;

export type ApiUrl = (typeof API_ENDPOINTS)[keyof typeof API_ENDPOINTS];
